import { Check, Lock } from 'lucide-react';

/**
 * LES PASTILLES QU'ON TIRE SUR LA PAGE.
 *
 * ⚠️ CELLES QUI NE SONT PAS ENCORE POSABLES SONT AFFICHÉES, GRISÉES, ET LE DISENT.
 *
 * La signature et les cases à cocher existent dans le modèle de données mais ne savent
 * pas encore s'écrire (ATL-8). Les cacher laisserait croire qu'elles n'existent pas et
 * ferait chercher ailleurs ; les proposer ferait promettre une pose qui n'aurait pas
 * lieu. On les montre, on les verrouille, et on écrit pourquoi.
 *
 * Le dépôt passe par `pointerdown` et non par HTML5 `draggable` : c'est le même geste,
 * le même code et le même hook que le déplacement d'une zone déjà posée. `draggable` est
 * fait pour TRANSFÉRER une donnée, pas pour positionner — et il embarque une image
 * fantôme qu'on ne maîtrise pas.
 */
export default function PaletteDeChamps({ champs, dejaPosees, onCommencerDepot }) {
  const poses = new Set(dejaPosees || []);
  return (
    <div className="flex lg:block gap-1 lg:gap-0 lg:space-y-1 overflow-x-auto lg:overflow-x-visible"
         data-testid="palette-de-champs">
      <p className="hidden lg:block text-[11px] text-neutral-500 mb-1.5">
        Tirez un champ sur la page pour dire où il s&apos;écrira.
      </p>
      {(champs || []).map((champ) => {
        const pose = poses.has(champ.cle);
        return (
          <button
            type="button"
            key={champ.cle}
            disabled={!champ.disponible}
            onPointerDown={(e) => champ.disponible && onCommencerDepot(e, champ.cle)}
            title={champ.disponible
              ? `Tirer « ${champ.libelle} » sur la page`
              : `Les champs de type « ${champ.famille} » ne savent pas encore s'écrire dans le mandat`}
            className={`w-auto lg:w-full shrink-0 flex items-center gap-1.5 text-left
                        text-[11.5px] px-2 py-2.5 lg:py-1.5 min-h-[44px] lg:min-h-0
                        rounded-md border transition-colors ${
              !champ.disponible
                ? 'border-neutral-200 bg-neutral-50 text-neutral-400 cursor-not-allowed'
                : pose
                  ? 'border-marque/40 bg-marque/5 text-marque cursor-grab'
                  : 'border-neutral-200 bg-white text-neutral-700 hover:bg-neutral-50 cursor-grab'}`}
            style={{ touchAction: 'none' }}
            data-testid={`palette-${champ.cle}`}
          >
            {!champ.disponible
              ? <Lock className="w-3 h-3 shrink-0" />
              : pose ? <Check className="w-3 h-3 shrink-0" /> : <span className="w-3" />}
            <span className="truncate">{champ.libelle}</span>
            {!champ.disponible && (
              <span className="ml-auto text-[9.5px] shrink-0">bientôt</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
